import { Routes, Route } from 'react-router-dom';
import { ShopLayout } from './layout/ShopLayout';
import { LandingPage } from './pages/LandingPage';
import { CategoryPage } from './pages/CategoryPage';
import { CommercialDcPage } from './pages/CommercialDcPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { CartPage } from './pages/CartPage';
import { CheckoutSuccessPage } from './pages/CheckoutSuccessPage';
import { SalesPartnerPage } from './pages/SalesPartnerPage';
import { InvitedSubmissionPage } from './pages/InvitedSubmissionPage';
import { IncentivesPage } from './pages/IncentivesPage';
import { WhyPage } from './pages/WhyPage';
import { NotFoundPage } from './pages/NotFoundPage';

/**
 * Shop routes, the real SEO-facing URLs. seo/seo.ts answers for each of them on
 * the server (status, title, canonical), so a new page goes in both places.
 */
export function App() {
  return (
    <Routes>
      <Route element={<ShopLayout />}>
        <Route index element={<LandingPage />} />
        <Route path="commercial-dc" element={<CommercialDcPage />} />
        <Route path="commercial-ac" element={<CategoryPage slug="commercial-ac" />} />
        <Route path="home-charging" element={<CategoryPage slug="home-charging" />} />
        <Route path="accessories" element={<CategoryPage slug="accessories" />} />
        <Route path="product/:id" element={<ProductDetailPage />} />
        <Route path="cart" element={<CartPage />} />
        <Route path="checkout/success" element={<CheckoutSuccessPage />} />
        <Route path="sales-partners" element={<SalesPartnerPage />} />
        {/* Invite-only submission door; the old public /submit-location is
            gone on purpose and falls through to the 404 below. */}
        <Route path="submit/:token" element={<InvitedSubmissionPage />} />
        <Route path="incentives" element={<IncentivesPage />} />
        <Route path="why/:icp" element={<WhyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
